<template>
    <component
            :is="tag"
            :style="{
                backgroundColor: color,
                opacity,
                height
            }"
            :class="{
                'loading-placeholder': true,
                'text-placeholder': true,
            }"
    >&nbsp;</component>
</template>

<script>
    import './text-loading-placeholder.scss';
    export default {
        name: 'TextLoadingPlaceholder',
        props: {
            tag: {
                type: String,
                default: 'span',
                required: false,
                validator: (val) => {
                    return [
                        'span',
                        'div',
                        'a',
                        'p',
                        'h1',
                        'h2',
                        'h3',
                        'h4',
                        'h5',
                        'h6',
                    ].indexOf(val) > -1;
                }
            },
            color: {
                type: String,
                default: '#444',
                required: false,
            },
            opacity: {
                type: Number,
                default: .1
            },
            fontSize: {
                type: [String, Number],
                required: false
            }
        },
        computed: {
            height: function () {
                if (!this.fontSize) {
                    return null;
                }
                if (typeof this.fontSize === "string") {
                    return this.fontSize;
                }
                return this.fontSize + 'px';

            }
        }
    }
</script>
